.header1 {
    font-family: var(--hps-secondary-font);
    font-size: 1.563rem;
    font-weight: bold;
    letter-spacing: 0.088rem;
    line-height: 2.063rem;
}
.header2 {
    font-family: var(--hps-primary-font);
    font-size: 1.188rem;
    font-weight: bold;
    letter-spacing: 0.019rem;
    line-height: 1.438rem;
}
.header3 {
    font-family: var(--hps-primary-font);
    font-size: 1.063rem;
    font-weight: bold;
    letter-spacing: 0.056rem;
    line-height: 1.25rem;
}
.linkTextSmall {
    font-family: var(--hps-primary-font);
    font-size: 0.688rem;
    font-weight: 600;
    letter-spacing: 0.044rem;
    line-height: .75rem;
    text-transform: uppercase;
}
.header4 {
    font-family: var(--hps-primary-font);
    font-size: 0.86rem;
    font-weight: bold;
    letter-spacing: 0.02rem;
    line-height: .75rem;
}
.header5 {
    font-family: var(--hps-primary-font);
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.02rem;
    line-height: .75rem;
}
.text1 {
    font-family: var(--hps-primary-font);
    font-size: 1.563rem;
    font-weight: bold;
    letter-spacing: 0.005rem;
    line-height: 1.875rem;
}
.text2 {
    font-family: var(--hps-primary-font);
    font-size: 1.063rem;
    font-weight: 600;
    letter-spacing: 0.043rem;
    line-height: 1.25rem;
}
.text3 {
    font-family: var(--hps-primary-font);
    font-size: 0.813rem;
    font-weight: 500;
    letter-spacing: 0.013rem;
    line-height: 1rem;
}
.text4 {
    font-family: var(--hps-primary-font);
    font-size: 0.688rem;
    font-weight: 600;
    letter-spacing: 0.029rem;
}

.preserveLineBreaks {
    white-space: pre-line;
}

.removeDefaultStyles {
    display: inline-block;
    margin: 0px;
    padding: 0px;
}

.caps {
    text-transform: uppercase;
}